var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowBarToLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3071 7.70711C14.6976 7.31658 14.6976 6.68342 14.3071 6.29289C13.9165 5.90237 13.2834 5.90237 12.8928 6.29289L8.59995 10.5858C7.8189 11.3668 7.8189 12.6332 8.59995 13.4142L12.8928 17.7071C13.2834 18.0976 13.9165 18.0976 14.3071 17.7071C14.6976 17.3166 14.6976 16.6834 14.3071 16.2929L11.0142 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H11.0142L14.3071 7.70711Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5C6.55228 5 7 5.44772 7 6V18C7 18.5523 6.55228 19 6 19C5.44772 19 5 18.5523 5 18V6C5 5.44772 5.44772 5 6 5Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowBarToLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconArrowBarToLeft.48b7a576bbd41e523f5d1fa6e30aadb7.svg";